import React from "react"
import { Button } from "primereact/button"
import { Card } from "primereact/card"
import { IconField } from "primereact/iconfield"
import { InputIcon } from "primereact/inputicon"
import { InputMask } from "primereact/inputmask"
import { InputText } from "primereact/inputtext"
import { peicarLogoSVG } from "../../../Assets/Images"




export const FormRegister = ({ handleSubmit, submit, register, errors, getValues, handleOnchage, handleTogglePassword, showPassword, message, getValue }) => {
    const footer = (
        <>
            <div className="containerBtn">
                <div className="col-12 p-2 ButtonContainer">
                    <Button
                        label="Crear cuenta"
                        className="w-full Green Button py-3"
                    />
                </div>
            </div>
            <div className="col-12 flex justify-content-center pt-1">
                <div
                    className="shadowCard"
                    style={{ height: "2rem", width: "80%" }}
                />
            </div>
        </>
    );

    const header = (
        <div style={{ padding: "4em" }}>
            <img alt="Card" src={peicarLogoSVG} />
        </div>
    );


    return (
        <form
            onSubmit={handleSubmit((data) => submit(data, 1))}
            className="grid"
        >
            <Card title="Registrate" style={{ background: "transparent" }} subTitle="Ingresa correo y contraseña" footer={footer} header={header} className="md:w-25rem shadow-none">

                <div className="col-12 p-2">
                    <InputText
                        // tooltip={errors["email"] ? 'Ingrese un correo válido' : null}
                        // tooltipOptions={{ event: 'focus', position: 'top' }}
                        maxLength={40}
                        {...register("name", {
                            required: true,
                            maxLength: 40,
                        })}
                        //   onChange={handleOnchage}
                        placeholder="Nombre"
                        className={
                            "EmailInput w-full TextInput " +
                            `${errors["name"] ? "p-invalid" : ""}`
                        }
                    />
                </div>
                <div className="col-12 p-2">
                    <InputText
                        // tooltip={errors["email"] ? 'Ingrese un correo válido' : null}
                        // tooltipOptions={{ event: 'focus', position: 'top' }}
                        maxLength={40}
                        {...register("email", {
                            required: true,
                            pattern:
                                /^(([^<>()\[\]\\.,;:\s@”]+(\.[^<>()\[\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z\s]{2,}))$/,
                            maxLength: 40,
                        })}
                        // si existe un email en el estado, se deshabilita el campo
                        //   disabled={ getValues("email") ? true : false }
                        //   onChange={handleOnchage}
                        placeholder="Correo electrónico"
                        className={
                            "EmailInput w-full TextInput " +
                            `${errors["email"] ? "p-invalid" : ""}`
                        }
                    />
                </div>
                <IconField iconPosition="right" className="w-full relative">
                    <div className="col-12 p-2">
                        <InputText
                            {...register("password", {
                                required: true,
                                minLength: 8,
                            })}
                            type={showPassword ? "text" : "password"}
                            placeholder="Contraseña"
                            className={
                                "w-full TextInput " + `${errors["password"] ? "p-invalid" : ""}`
                            }
                        />
                    </div>
                    <InputIcon
                        onClick={handleTogglePassword}
                        style={{
                            position: "absolute",
                            right: "1.5em",
                            top: "50%",
                            transform: "translateY(-50%)",
                            zIndex: 100,
                            cursor: "pointer",
                            '& .p-input-icon ': {
                                top: "0",
                            },
                        }}
                        className={` ${showPassword ? "pi pi-eye-slash" : "pi pi-eye"
                            } pointer eyePassMobile`}
                    />
                </IconField>

                <div className="col-12 p-2">
                    <InputText
                        {...register("confirmPassword", {
                            required: true,
                            validate: (value) =>
                                value === getValues("password") || "Las contraseñas no coinciden", // Validación
                        })}
                        type="password"
                        placeholder="Confirmar Contraseña"
                        className={`w-full TextInput ${errors["confirmPassword"] ? "p-invalid" : ""}`}
                    />

                </div>
                <div className="col-12 ">
                    {/* <InputMask
                        {...register("phone", { required: true })}
                        mask=" +52 99 9999-9999"
                        placeholder=" +52 (99) 9999-9999"
                        className={`w-full TextInput ${errors["phone"] ? "p-invalid" : ""}`}
                    /> */}
                    <InputText
                        {...register("phone", { required: true })}
                        // onChange={handleOnchage}
                        placeholder="Teléfono"
                        className={`w-full TextInput ${errors["phone"] ? "p-invalid" : ""}`}
                    />

                </div>
                <div className="Container">
                    {(message ||
                        errors["email"] ||
                        errors["password"] ||
                        errors["confirmPassword"]) && (
                            <div className="ErrorMessage">
                                {message && (
                                    <span className="ErrorText">
                                        {message}
                                        <br />
                                    </span>
                                )}

                            </div>
                        )}
                </div>

                <div className="containerBtn">


                </div>


            </Card >
        </form>
    )
}